import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["newAccountForm", "errorContainer"]

  static values = {
    translations: Object
  }

  async createNewBankAccount(event) {
    event.preventDefault()

    if (!this.hasNewAccountFormTarget) {
      return
    }

    this.clearFormErrors()
    const formData = new FormData(this.newAccountFormTarget)

    if (this.bankAccountFormatValidator(formData.get("bank_account[bank_account_number]"))) {
      const response = await fetch("/modal/bank_accounts.json", {
        method: this.newAccountFormTarget.method || "POST",
        headers: {
          Accept: "application/json",
          "X-Requested-With": "XMLHttpRequest",
          "X-CSRF-Token": document.querySelector("meta[name=\"csrf-token\"]")?.content
        },
        body: formData
      })

      const data = await response.json()
      if (response.ok) {
        window.dispatchEvent(new CustomEvent("bank-account:create", { detail: { bank_account: data.bank_account_version } }))
        this.dispatch("success")
        this.clearNewAccountForm()
      } else {
        this.displayFormErrors(data.errors)
      }
    } else {
      this.displayFormErrors([this.translationsValue["bank_account_number"]])
    }
  }

  displayFormErrors(errors) {
    if (!this.hasErrorContainerTarget) {
      return
    }

    this.clearFormErrors()

    let errorListItems = ""
    Object.keys(errors).forEach(field => {
      const fieldErrors = Array.isArray(errors[field]) ? errors[field] : [errors[field]]
      fieldErrors.forEach(error => {
        errorListItems += `<li>${error}</li>`
      })
    })

    this.errorContainerTarget.insertAdjacentHTML("afterbegin", errorListItems)
    this.errorContainerTarget.classList.remove("hidden")
  }

  clearNewAccountForm() {
    if (this.hasNewAccountFormTarget) {
      document.querySelectorAll(`input[type="text"][id^=bank_account_`).forEach((elem) => { elem.value = null })

      this.clearFormErrors()
    }
  }

  clearFormErrors() {
    this.errorContainerTarget.classList.add("hidden")
    if (this.hasErrorContainerTarget) {
      this.errorContainerTarget.innerHTML = ""
    }
  }

  /** podstawowa walidacja, zeby nie mozna bylo dodac samego tekstu, bo backend nei ma walidacji */
  bankAccountFormatValidator(bankAccountNumber) {
    if (!bankAccountNumber) return false

    const value = bankAccountNumber.replace(/\s+/g, "").toUpperCase()

    if (value.length < 15 || value.length > 34) return false

    return /^(?:[A-Za-z]{2})?\d+$/.test(value)
  }
}
